'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddToList = require('./components/AddToList.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddToList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-to-list/index.js
// module id = 1031
// module chunks = 0